import React, { useEffect } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { Drawer } from 'vaul';

interface BottomSheetProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: React.ReactNode;
  height?: string;
}

export const BottomSheet: React.FC<BottomSheetProps> = ({
  isOpen,
  onOpenChange,
  title,
  description,
  children,
  height = '75vh',
}) => {
  useEffect(() => {
    if (isOpen) {
      // Drawerが開いたときに、フォーカスされている要素からblurする
      const activeElement = document.activeElement as HTMLElement;
      if (activeElement && activeElement.blur) {
        activeElement.blur();
      }
    }
  }, [isOpen]);

  return (
    <Drawer.Root open={isOpen} onOpenChange={onOpenChange} dismissible={true} modal={true}>
      <Drawer.Portal>
        <Drawer.Overlay
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            zIndex: 50,
          }}
        />
        <Drawer.Content
          style={{
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'column',
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            height: height,
            borderTopLeftRadius: '24px',
            borderTopRightRadius: '24px',
            zIndex: 50,
          }}
        >
          <Box p={4} borderBottom="1px solid" borderColor="gray.200" userSelect="none">
            <Box w="40px" h="4px" bg="gray.300" borderRadius="full" mx="auto" mb={4} />
            <Drawer.Title style={{ margin: 0, padding: 0 }}>
              <Text fontSize="lg" fontWeight="bold" textAlign="center" color="gray.800">
                {title}
              </Text>
            </Drawer.Title>
            <Drawer.Description
              style={{
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: 0,
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0, 0, 0, 0)',
                whiteSpace: 'nowrap',
                borderWidth: 0,
              }}
            >
              {description || title}
            </Drawer.Description>
          </Box>

          <Box flex={1} overflowY="auto" p={6} color="gray.700">
            {children}
          </Box>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};
